import { serverAddr } from "../networkConfig";
import { async } from "q";

export default {
	// article master apis
	createArticleMater(params) {
		return serverAddr.post("/outlet/article/", params);
	},
	getDepartments({ get_all = false } = {}) {
		return serverAddr
			.get(`/product/department/?get_all=${get_all}`)
			.catch(err => {
				console.log(err);
			});
	},
	getCategories({ fields = [], departmentId, get_all = false } = {}) {
		if (fields.length)
			return serverAddr.get(
				`/product/category/?fields=${fields}&department=${departmentId}&get_all=${get_all}`
			);
		else
			return serverAddr.get(
				`/product/category/?department=${departmentId}&get_all=${get_all}`
			);
	},
	getSubcategories({ fields = [], categoryId, get_all = false } = {}) {
		if (fields.length)
			return serverAddr.get(
				`/product/subcategory/?fields=${fields}&category=${categoryId}&get_all=${get_all}`
			);
		else
			return serverAddr.get(
				`/product/subcategory/?category=${categoryId}&get_all=${get_all}`
			);
	},
	doesDepartmentExist({ departmentId } = {}) {
		return serverAddr.get(`/product/department/${departmentId}`);
	},
	doesCategoryExist({ categoryId } = {}) {
		return serverAddr.get(`/product/category/${categoryId}`);
	},
	doesSubcategoryExist({ subcategoryId } = {}) {
		return serverAddr.get(`/product/subcategory/${subcategoryId}/`);
	},
	createDepartment({ name } = {}) {
		return serverAddr
			.post("/product/department/", {
				name
			})
			.catch(err => {
				console.log(err);
			});
	},
	createCategory(params) {
		return serverAddr.post("/product/category/", params).catch(err => {
			console.log(err);
		});
	},
	createSubCategory(params) {
		return serverAddr.post("/product/subcategory/", params).catch(err => {
			console.log(err);
		});
	},
	createArticleMaster({ outlets = [], articles = [] } = {}) {
		return serverAddr
			.post("/outlet/article/", { outlets, articles })
			.catch(err => {
				console.log(err);
			});
	},
	getArticlesForOutlet({
		outletId,
		fields = [],
		get_all = false,
		pageInfo
	} = {}) {
		return serverAddr.get(`
		outlet/${outletId}/article/?fields=${fields}&get_all=${get_all}&page=${
			pageInfo.currentPage
		}&page_size=${pageInfo.pageSize}`);
	},
	getSearchArticlesForOutlet({
		outletId,
		fields = [],
		get_all = false,
		pageInfo,
		search_string
	} = {}) {
		return serverAddr.get(`
		outlet/${outletId}/article/?search_string=${search_string}&page=${
			pageInfo.currentPage
		}&page_size=${pageInfo.pageSize}`);
	},
	updateArticle({ outletId, articleCode, article } = {}) {
		return serverAddr.patch(
			`/outlet/${outletId}/article/${articleCode}/update/article/`,
			article
		);
	},
	deleteArticle({ outletId, articleCode } = {}) {
		return serverAddr.delete(`/outlet/${outletId}/article/${articleCode}/`);
	}
};
